var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgFixedAnnuity = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#003865",
    fillRule: "evenodd",
    d: "M15.143 1.987h-.001H18v14.08a1.93 1.93 0 0 1-1.795 1.914l-.152.005L2 17.985V3.906c0-1.012.793-1.838 1.795-1.914l.152-.006 11.196.001ZM17 6H3l-.001 10.985 13.054.002a.937.937 0 0 0 .94-.813l.007-.106V5.999ZM8.5 14v-1h1.998a.491.491 0 0 0 .502-.5.478.478 0 0 0-.405-.492L10.5 12h-1A1.47 1.47 0 0 1 8 10.5c0-.803.574-1.423 1.352-1.493L9.5 9V8h1v1h1v1h-2c-.3 0-.5.2-.5.5 0 .267.158.454.404.493L9.5 11h1.003c.85.005 1.497.663 1.497 1.5a1.49 1.49 0 0 1-1.353 1.493L10.5 14v1h-1v-1h-1Zm5.785-11.014H3.947a.938.938 0 0 0-.94.813L3 3.906V5h14V2.987h-2.715Z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgFixedAnnuity);
export default ForwardRef;